import { Module } from 'vuex';

import tool from '@/utils/tool';
import RootModuleTypes from '@/store/interface';
import NewsModuleTypes from '@/store/modules/middleGround/my/news/interface';

const newsModule: Module<NewsModuleTypes, RootModuleTypes> = {
    namespaced: true,
    state: {

    },
    mutations: {

    },
    actions: {
        pageRssActivityReadList(context, searchParams) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/pageRssActivityReadList", searchParams).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        updateRssActivityReadStatus(context, params) {
            return new Promise((resolve, reject) => {
                tool.post("/personalCenter/updateRssActivityReadStatus", params).then(data => {
                    if (data.status === 2000) {
                        resolve(data);
                    }
                    else {
                        reject(data);
                    }
                });
            });
        },
        
        
    },
};

export default newsModule;